import React, { useMemo, useState } from "react";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { toolbarCommands } from "components/organisms/manuscript/editor/commands";

const TableGridPopover = styled.div`
    padding: 8px;
    border: 1px solid #d8e1ec;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
`;

const TableGridLabel = styled.div`
    margin-bottom: 8px;
    color: #42576b;
    font-size: 11px;
    font-weight: 600;
`;

const TableGrid = styled.table`
    border-collapse: separate;
    border-spacing: 3px;
`;

const TableGridCell = styled.td`
    width: 16px;
    height: 16px;
    padding: 0;
    border: 1px solid ${(props) => (props.$active ? "#0f8f6f" : "#d8e1ec")};
    border-radius: 2px;
    background: ${(props) => (props.$active ? "rgba(15, 143, 111, 0.14)" : "#ffffff")};
    cursor: pointer;
`;

const range = (start, end) => Array.from({ length: end - start + 1 }, (_, index) => index + start);

function SizeGrid({ sizeX, sizeY, onSizeSelected }) {
    const [currentSize, setCurrentSize] = useState({ sizeX: 0, sizeY: 0 });

    const label = useMemo(() => {
        if (currentSize.sizeX > 0 && currentSize.sizeY > 0) {
            return `${currentSize.sizeY}×${currentSize.sizeX} 표 삽입`;
        }

        return "표 삽입";
    }, [currentSize]);

    return (
        <>
            <TableGridLabel>{label}</TableGridLabel>
            <TableGrid
                onMouseLeave={() => {
                    setCurrentSize({ sizeX: 0, sizeY: 0 });
                }}
            >
                <tbody>
                    {range(1, sizeY).map((row) => (
                        <tr key={row}>
                            {range(1, sizeX).map((col) => (
                                <TableGridCell
                                    key={`${row}-${col}`}
                                    $active={currentSize.sizeX >= col && currentSize.sizeY >= row}
                                    onMouseEnter={() => {
                                        setCurrentSize({ sizeX: col, sizeY: row });
                                    }}
                                    onMouseUp={() => onSizeSelected(col, row)}
                                    aria-label={`${row} x ${col} 표 삽입`}
                                />
                            ))}
                        </tr>
                    ))}
                </tbody>
            </TableGrid>
        </>
    );
}

function ManuscriptTableDropdown({
    Button,
    disabled,
    iconColor,
    runEditorCommand,
    open,
    onOpenChange,
    dropdownUsePortal = true,
}) {
    const handleSizeSelected = (sizeX, sizeY) => {
        onOpenChange(false);
        runEditorCommand((view) => toolbarCommands.insertTable(view, sizeX, sizeY));
    };

    return (
        <Tooltip message="표">
            <Dropdown
                open={open}
                onOpenChange={onOpenChange}
                placement="bottom-start"
                offset={6}
                anchor={
                    <Button
                        type="button"
                        onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                        }}
                        onClick={() => {
                            if (disabled) return;
                            onOpenChange(!open);
                        }}
                        disabled={disabled}
                        aria-label="표 삽입"
                    >
                        <Icon name={"table"} size={"12px"} color={iconColor} />
                    </Button>
                }
                contentMinWidth="220px"
                usePortal={dropdownUsePortal}
            >
                <TableGridPopover role="group" aria-label="표 크기 선택">
                    <SizeGrid sizeX={10} sizeY={10} onSizeSelected={handleSizeSelected} />
                </TableGridPopover>
            </Dropdown>
        </Tooltip>
    );
}

export default React.memo(ManuscriptTableDropdown);
